import { render, staticRenderFns } from "./TabGeneral.vue?vue&type=template&id=7d68009c&scoped=true"
import script from "./TabGeneral.vue?vue&type=script&lang=js"
export * from "./TabGeneral.vue?vue&type=script&lang=js"
import style0 from "./TabGeneral.vue?vue&type=style&index=0&id=7d68009c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68009c",
  null
  
)

export default component.exports